
import { defineComponent, getCurrentInstance, ref, onMounted } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { SMUser } from "@/store";

export default defineComponent({
  name: "Table",

  setup() {
    const router = getCurrentInstance()?.proxy?.$router;

    const headers = [
      {
        label: "Name",
        value: "name",
        span: 2,
      },
      {
        label: "Job position",
        value: "job_position",
      },
      {
        label: "Visa Expiry Date",
        value: "visa_expiry_date",
        sort: true,
        sortBy: "date",
      },
      {
        label: "Action",
        value: "actions",
        span: 0.5,
      },
    ];

    const employees = ref([]);

    const loading = ref(false);

    async function fetchEmployeesExtension() {
      try {
        loading.value = true;

        const { data } = await axios.get(API_ROUTES.COMPANY_EMPLOYEES_EXTENSION);

        if (!data) return;

        employees.value = data;
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => fetchEmployeesExtension());

    async function onSelect({ id, name }: { id: number; name: string }) {
      if (!id) return;

      try {
        await router.push(`${SMUser.basePath}/services/extension/${id}?name=${name}`);
      } catch {
        return;
      }
    }

    return {
      headers,
      employees,
      loading,
      onSelect,
    };
  },
});
